<template>
  <submit-documents-modal :active="active"
    :quote-id="quoteId"
    title="Submit Documents"
    subtitle="Select documents to submit"
    :is-audanet="true"
    :submit-disabled="isSubmitting"
    @submit="onSubmit"
    @cancel="cancel" />
</template>

<script>
// Thin AudaNet/Bridge wrapper around the shared SubmitDocumentsModal. The dialog/selector
// are shared components (src/components/DocumentSelect); this only wires the submit to AudaNet.
import SubmitDocumentsModal from '@/components/DocumentSelect/SubmitDocumentsModal.vue'
import { AudaNetService } from '../services'
import { EventHubTypes } from '@/enums'

export default {
  name: 'AudabridgeSubmitDocumentsModal',
  components: {
    SubmitDocumentsModal
  },
  props: {
    value: null,
    quoteId: {
      type: String,
      default: ''
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isSubmitting: false
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    async onSubmit({ documents, resetSent }) {
      this.isSubmitting = true
      this.$showSpinner('Submitting documents')
      try {
        const documentIds = documents.map((d) => d.quoteAttachmentId)
        const result = await AudaNetService.submitMultipleDocuments(this.quoteId, documentIds, resetSent)
        this.$hideSpinner()
        const data = result && result.data ? result.data : null
        if (data && data.error) {
          // Some/all documents failed; the ones that uploaded are already saved, so warn
          // on partial success and only show danger when nothing was sent (mirrors EstImage).
          const type = data.successCount > 0 ? 'warning' : 'danger'
          this.$notification.openNotificationWithType(type, 'Submit documents to AudaNet', data.details)
        } else {
          this.$notification.openNotificationWithType('success', 'Documents', 'Documents uploaded successfully', 4000)
        }
        this.$eventHub.$emit(EventHubTypes.EntityReload)
      } catch (e) {
        this.$hideSpinner()
        this.$notification.openNotificationWithType('danger', 'Documents', 'Failed to submit documents')
      } finally {
        this.isSubmitting = false
        this.$emit('cancel')
      }
    }
  }
}
</script>
